import { capitalizeFirstLetter } from '@lib/utils';

/** Setter for a single store key, as created by `createSingleKeySetter`. */
export type SingleKeySetter<T, K extends keyof T> = (...args: [T[K]?]) => void;

type SetFunction<T> = (
    partial: Partial<T> | ((state: T) => Partial<T>),
    replace?: false,
    actionName?: string,
) => void;

export const createSingleKeySetter =
    <T, K extends keyof T>(
        set: SetFunction<T>,
        key: K,
        prefix: string,
        defaultValue?: T[K],
    ): SingleKeySetter<T, K> =>
    (...args: [T[K]?]): void => {
        const finalValue = args.length > 0 ? args[0] : defaultValue;

        set(
            { [key]: finalValue } as Partial<T>,
            undefined,
            `${prefix}/set${capitalizeFirstLetter(String(key))}`,
        );
    };
